import React from "react";
import { API_URL } from "../../../constants";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../services/serviceCaller";
import Dynamic_PR_table from "../../../components/Dynamic_PR_table";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const CurrencyMaster = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    fetchReportList();

    dispatch(updateNavbarHeading("Currency Master"));
  }, []);

  const navigate = useNavigate();
  const [reportList, setReplortList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [apiStatus, setApiStatus] = useState(undefined);
  const fetchReportList = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}currency-master`);
      if (response?.status === 200) {
        setApiStatus(response?.status);
        setReplortList(response?.data?.data?.data.reverse());
      }
    } catch (error) {
      console.error("Error fetching reports", error);
    }
  };

  const columns = {
    Code: { text: "Code", visible: true },
    Name: { text: "Name", visible: true },
    CurrencySymbol: { text: "Currency Symbol", align: "center", visible: true },
    DecimalPrecisionName: {
      text: "Decimal Precision Name",
      align: "center",
      visible: true,
    },
    IsInActive: { text: "Active", align: "center", visible: true },
  };

  const handleEdit = (id) => {
    navigate(`/currency-master/edit/${id.ID}`);
  };

  const handleAddCurrencyMaster = () => {
    navigate("/currency-master/add");
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid " id="skill-table-area">
          <div className="row">
            <Dynamic_PR_table
              data={reportList}
              columns={columns}
              itemsPerPage={10}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              isSorting={true}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              showIcon3={false}
              showIcon4={false}
              showIcon5={false}
              handleIcon1={handleEdit}
              handleAddNew={handleAddCurrencyMaster}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              // handleIcon3={handleView}
              add
              more
              function
              icons={{
                Icon1: <i class="bi bi-pencil-square icons"></i>,
                Icon2: <i class="bi bi-trash-fill icons"></i>,
                Icon3: <i class="bi bi-eye-fill icons"></i>,
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrencyMaster;
